import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { 
  FaHandshake, 
  FaUsers, 
  FaGraduationCap, 
  FaLightbulb, 
  FaLink, 
  FaBullseye,
  FaServer,
  FaShieldAlt,
  FaNetworkWired,
  FaRocket
} from 'react-icons/fa';

const PRIMARY_RED = '#bf2e1a';
const PRIMARY_BLACK = '#1a202c';
const WHITE = '#fff';

const AboutPage = () => {
  const companyValues = [
    {
      Icon: FaHandshake,
      title: 'שותפות משפחתית',
      description: 'מחויבות וכבוד הדדי בין החברה לעובדיה, תוך תמיכה והערכה בכל עת, הן בהצלחה והן במשבר.'
    },
    {
      Icon: FaUsers,
      title: 'לקוחות',
      description: 'הנכס היקר ביותר של הלקוח נמצא אצלנו ואנו מחויבים לשמור עליו ולספק ללקוחותינו את השירות הטוב ביותר.'
    },
    {
      Icon: FaGraduationCap,
      title: 'מומחיות ומקצועיות',
      description: 'פיתוח ההון האנושי, לקיחת אחריות ולימוד מתמיד בכל תחום ותחום.'
    },
    {
      Icon: FaLightbulb,
      title: 'יזמות וחדשנות',
      description: 'שואפים לשיפורים, צמצום עלויות תפעול ויעילות תפעולית תוך הכנסת טכנולוגיות חדשות, בדגש על שיפור תהליכים באבטחה ובשירות לקוחות.'
    },
    {
      Icon: FaLink,
      title: 'אינטגרטיביות ושיתוף פעולה',
      description: 'פועלים בשקיפות מלאה בתוך החברה ובשיתוף מידע ובשיתוף פעולה עם כל הגורמים כולל חברות בקבוצה, במטרה לקדם את האינטרסים של הלקוחות ושל בעלי המניות.'
    },
    {
      Icon: FaBullseye,
      title: 'גישה תוצאתית',
      description: 'יעילות ומוכוונות לתפוקות בעלות ערך ללקוחותינו, תוך שימת דגש על מצוינות בשירות.'
    }
  ];

  return (
    <Container className="py-5" dir="rtl" style={{ maxWidth: '1200px' }}>
      {/* Header Section */}
      <Row className="mb-5">
        <Col className="text-center">
          <h1 style={{ 
            color: PRIMARY_RED, 
            fontSize: '3rem', 
            fontWeight: 'bold', 
            marginBottom: '1rem',
            letterSpacing: '1px'
          }}>
            אודות הפורטל והחברה
          </h1>
          <div style={{ 
            width: '100px', 
            height: '4px', 
            backgroundColor: PRIMARY_RED, 
            margin: '0 auto 2rem auto',
            borderRadius: '2px'
          }} />
        </Col>
      </Row>

      {/* Company Overview */}
      <Row className="mb-5">
        <Col lg={6} className="mb-4">
          <Card style={{ 
            border: 'none', 
            borderRadius: '12px', 
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)', 
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
          }}>
            <Card.Body className="p-4">
              <h2 style={{ 
                color: PRIMARY_RED, 
                fontWeight: 'bold',
                fontSize: '1.8rem',
                marginBottom: '1.5rem',
                borderBottom: `3px solid ${PRIMARY_RED}`,
                paddingBottom: '0.5rem'
              }}>
                על החברה
              </h2>
              <p style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '1.9', 
                fontSize: '1.05rem',
                marginBottom: '1rem',
                textAlign: 'justify'
              }}>
                <strong style={{ color: PRIMARY_RED }}>בינת דאטה סנטרס</strong> מספקת פתרונות אירוח 360 ללקוחותיה הישראלים והבינלאומיים ב-7 חוות שרתים המתקדמות ותת קרקעיות באמצעות צוות הפעלה ומומחים רחב.
              </p>
              <p style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '1.9', 
                fontSize: '1.05rem',
                marginBottom: '1rem',
                textAlign: 'justify'
              }}>
                החברה מפעילה 7 מתקני דאטה סנטר תת קרקעיים בישראל, מהמתקדמים והבטוחים מסוגם, הכוללים מערכות אבטחה מתקדמות (CCTV, מאבטחים 24/7, בקרת גישה ביומטרית), המבטיחים גיבוי ורציפות תפקודית לארגון. אנו מספקים שירותי תמיכה מלא ורציף, כולל אתחול שרתים, בדיקות תקינות, ג'ימפורים והחלפת דיסקים, וכן שירותי Service Provider מגוונים מכל מתקני הדאטה סנטר.
              </p>
              <p style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '1.9', 
                fontSize: '1.05rem',
                textAlign: 'justify',
                fontStyle: 'italic',
                borderTop: `1px solid #e0e0e0`,
                paddingTop: '1rem',
                marginTop: '1rem'
              }}>
                החברה שייכת לקבוצת רד-בינת, קבוצה ותיקה של מעל 40 שנה, המחויבת לפעילות עסקית הוגנת, תרומה לחברה ומעורבות קהילתית והכלכלה הישראלית.
              </p>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} className="mb-4">
          <Card style={{ 
            border: 'none', 
            borderRadius: '12px', 
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)', 
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
          }}>
            <Card.Body className="p-4">
              <h2 style={{ 
                color: PRIMARY_RED, 
                fontWeight: 'bold',
                fontSize: '1.8rem',
                marginBottom: '1.5rem',
                borderBottom: `3px solid ${PRIMARY_RED}`,
                paddingBottom: '0.5rem'
              }}>
                על הפורטל
              </h2>
              <p style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '1.9', 
                fontSize: '1.05rem',
                marginBottom: '1rem',
                textAlign: 'justify'
              }}>
                פורטל העובדים של בינת דאטה סנטרס הוא המרכז הדיגיטלי המחבר את כל חברי הצוות. הפורטל מספק פלטפורמה מקיפה לתקשורת פנימית, שיתוף מידע וניהול פעילויות ארגוניות.
              </p>
              <p style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '1.9', 
                fontSize: '1.05rem',
                marginBottom: '1rem',
                textAlign: 'justify'
              }}>
                באמצעות הפורטל, העובדים יכולים:
              </p>
              <ul style={{ 
                color: PRIMARY_BLACK, 
                lineHeight: '2', 
                fontSize: '1.05rem',
                paddingRight: '1.5rem',
                marginBottom: '0'
              }}>
                <li>לקבל עדכונים וחדשות ארגוניות</li>
                <li>לצפות בהוקרות והישגים של עמיתים</li>
                <li>להשתתף בתקשורת פנימית ובצ'אט חי</li>
                <li>לגשת לקישורים חשובים ומשאבים ארגוניים</li>
                <li>לצפות במבנה הארגוני ובמידע על הצוות</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Company Values - 6 Circles */}
      <Row className="mb-5">
        <Col className="text-center mb-4">
          <h2 style={{ 
            color: PRIMARY_RED, 
            fontWeight: 'bold',
            fontSize: '2.2rem',
            marginBottom: '0.5rem'
          }}>
            רוח החברה
          </h2>
          <p style={{ 
            color: PRIMARY_BLACK, 
            fontSize: '1.1rem',
            marginBottom: '2rem',
            maxWidth: '800px',
            margin: '0 auto 2rem auto'
          }}>
            ערכי היסוד המנחים את פעילותנו ומייצגים את הדרך בה אנו עושים עסקים
          </p>
        </Col>
      </Row>

      <Row className="g-4 mb-5">
        {companyValues.map((value, index) => {
          const IconComponent = value.Icon;
          return (
          <Col md={6} lg={4} key={index}>
            <Card style={{ 
              border: 'none', 
              borderRadius: '12px', 
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              height: '100%',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              backgroundColor: '#ffffff'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = `0 8px 24px rgba(191, 46, 26, 0.15)`;
              e.currentTarget.style.borderTop = `4px solid ${PRIMARY_RED}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
              e.currentTarget.style.borderTop = 'none';
            }}>
              <Card.Body className="p-4" style={{ textAlign: 'center' }}>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  backgroundColor: PRIMARY_RED, 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto 1.5rem auto',
                  color: WHITE,
                  boxShadow: `0 4px 12px rgba(191, 46, 26, 0.3)`
                }}>
                  <IconComponent size={36} />
                </div>
                <h3 style={{ 
                  color: PRIMARY_RED, 
                  fontWeight: 'bold',
                  fontSize: '1.3rem',
                  marginBottom: '1rem',
                  minHeight: '3rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {value.title}
                </h3>
                <p style={{ 
                  color: PRIMARY_BLACK, 
                  lineHeight: '1.8', 
                  fontSize: '0.95rem',
                  textAlign: 'justify',
                  margin: '0'
                }}>
                  {value.description}
                </p>
              </Card.Body>
            </Card>
          </Col>
          );
        })}
      </Row>

      {/* Vision Section */}
      <Row className="mb-5">
        <Col>
          <Card style={{ 
            border: 'none', 
            borderRadius: '12px', 
            background: `linear-gradient(135deg, ${PRIMARY_RED} 0%, #a02615 100%)`,
            color: WHITE,
            boxShadow: '0 4px 20px rgba(191, 46, 26, 0.25)'
          }}>
            <Card.Body className="p-5">
              <Row className="align-items-center">
                <Col lg={8}>
                  <h2 style={{ 
                    fontWeight: 'bold',
                    fontSize: '2rem',
                    marginBottom: '1.5rem'
                  }}>
                    החזון שלנו
                  </h2>
                  <p style={{ 
                    fontSize: '1.15rem', 
                    lineHeight: '1.9', 
                    marginBottom: '1rem'
                  }}>
                    להיות המובילים בישראל בפתרונות אירוח ותשתיות דאטה סנטר, תוך שמירה על רמת שירות גבוהה, חדשנות טכנולוגית ומחויבות מתמדת ללקוחותינו ולצוות שלנו.
                  </p>
                  <p style={{ 
                    fontSize: '1.15rem', 
                    lineHeight: '1.9',
                    marginBottom: '0'
                  }}>
                    אנו מאמינים בכוחו של הצוות המקצועי שלנו - אנשים מוכשרים, יצירתיים ומחויבים שמביאים עימם ידע, ניסיון ותשוקה לחדשנות. יחד אנו בונים את העתיד הדיגיטלי של ישראל.
                  </p>
                </Col>
                <Col lg={4} className="text-center">
                  <div style={{
                    fontSize: '5rem',
                    opacity: '0.9',
                    color: 'rgba(255, 255, 255, 0.9)'
                  }}>
                    <FaRocket size={80} />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Contact Info */}
      <Row>
        <Col>
          <Card style={{ 
            border: 'none', 
            borderRadius: '12px', 
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            backgroundColor: '#f8f9fa'
          }}>
            <Card.Body className="p-4">
              <h4 style={{ 
                color: PRIMARY_RED, 
                fontWeight: 'bold', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                צריכים עזרה או יש לכם שאלות?
              </h4>
              <p style={{ 
                color: PRIMARY_BLACK, 
                margin: '0 0 1.5rem 0',
                textAlign: 'center',
                fontSize: '1.05rem'
              }}>
                צוות הפיתוח שלנו זמין תמיד לעזור ולשפר את החוויה שלכם בפורטל.
              </p>
              
              <div style={{ 
                backgroundColor: '#ffffff', 
                borderRadius: '10px', 
                padding: '1.5rem', 
                marginTop: '1rem',
                border: `2px solid ${PRIMARY_RED}`,
                maxWidth: '600px',
                margin: '1rem auto 0 auto'
              }}>
                <h5 style={{ 
                  color: PRIMARY_RED, 
                  fontWeight: 'bold', 
                  marginBottom: '0.5rem',
                  textAlign: 'center'
                }}>
                  מפתח הפורטל
                </h5>
                <p style={{ 
                  color: PRIMARY_BLACK, 
                  margin: '0 0 0.5rem 0', 
                  fontWeight: '500',
                  textAlign: 'center',
                  fontSize: '1.05rem'
                }}>
                  <strong>מאיר שובקס</strong>
                </p>
                <p style={{ 
                  color: PRIMARY_BLACK, 
                  margin: '0 0 1rem 0', 
                  fontSize: '0.95rem',
                  textAlign: 'center'
                }}>
                  מפתח Full-Stack ומעצב UX/UI | אחראי על פיתוח ועיצוב הפורטל
                </p>
                
                <div style={{ 
                  textAlign: 'center',
                  fontSize: '0.95rem',
                  color: PRIMARY_BLACK
                }}>
                  <p style={{ margin: '0.5rem 0' }}>
                    📧 <strong>Email:</strong> Meir.Shuvax@bynetdcs.co.il
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutPage;
